/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown>, days: NonNullable<unknown> }} Profile_Reminder_ValueInputs */

const en_us2_profile_reminder_value = /** @type {(inputs: Profile_Reminder_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} · ${i?.days}`)
};

const pt_br2_profile_reminder_value = /** @type {(inputs: Profile_Reminder_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} · ${i?.days}`)
};

const es_419_profile_reminder_value = /** @type {(inputs: Profile_Reminder_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} · ${i?.days}`)
};

const pt_pt2_profile_reminder_value = /** @type {(inputs: Profile_Reminder_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} · ${i?.days}`)
};

const fr_fr2_profile_reminder_value = /** @type {(inputs: Profile_Reminder_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} · ${i?.days}`)
};

const de_de2_profile_reminder_value = /** @type {(inputs: Profile_Reminder_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} · ${i?.days}`)
};

const it_it2_profile_reminder_value = /** @type {(inputs: Profile_Reminder_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} · ${i?.days}`)
};

/**
* | output |
* | --- |
* | "{time} · {days}" |
*
* @param {Profile_Reminder_ValueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_reminder_value = /** @type {((inputs: Profile_Reminder_ValueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Reminder_ValueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_reminder_value(inputs)
	if (locale === "es-419") return es_419_profile_reminder_value(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_reminder_value(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_reminder_value(inputs)
	if (locale === "de-DE") return de_de2_profile_reminder_value(inputs)
	if (locale === "it-IT") return it_it2_profile_reminder_value(inputs)
	return en_us2_profile_reminder_value(inputs)
});
export { profile_reminder_value as "profile.reminder_value" }